export default "__VITE_ASSET__GRCocp86__"